import { Form } from "react-bootstrap"
import BaseControl from "./BaseControl"

const SwitchControl = ({
    text="Text",
    caption="",
    edit=true,
    value=true,
    onChanged=(val:boolean) => {}}) => {
    const _onChanged = (val:any) => {
        //console.log(val.target.checked)
        onChanged(val.target.checked);
    }
    return <BaseControl text={text} caption={caption}>
        <>
        { <Form.Check 
            disabled={!edit} 
            value={value ? "1" : "0"}
            type="switch" 
            checked={value}
            onChange={_onChanged}/>}
        </>
    </BaseControl>
}

export default SwitchControl